import { render } from "./CattleImport.vue?vue&type=template&id=4d19375a&ts=true"
import script from "./CattleImport.vue?vue&type=script&lang=ts"
export * from "./CattleImport.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__